import { Card, FormField } from '@playerbase/ui';
import { PLAYTEST_RECRUITMENT_INSTRUCTIONS_MAX } from '@playerbase/types';

interface PairingInstructionsCardProps {
  value: string;
  onChange: (next: string) => void;
}

const FIELD_LABEL_CLASS =
  'font-mono text-[10px] font-semibold uppercase tracking-wider text-text-muted';

// Studio-supplied "where to enter your code in the game" copy. Included
// verbatim in the post-button DM the bot sends in PR 2.
export function PairingInstructionsCard({
  value,
  onChange,
}: PairingInstructionsCardProps): JSX.Element {
  return (
    <Card>
      <Card.Header>
        <Card.Title>Pairing instructions</Card.Title>
        <Card.Description>
          Tell your tester where in the game they paste the pairing code.
          The bot includes this verbatim in the DM it sends right after they
          tap the button.
        </Card.Description>
      </Card.Header>
      <Card.Content>
        <FormField>
          <FormField.Label className={FIELD_LABEL_CLASS}>
            Instructions
          </FormField.Label>
          <FormField.Control>
            <textarea
              value={value}
              onChange={(e) => onChange(e.target.value)}
              maxLength={PLAYTEST_RECRUITMENT_INSTRUCTIONS_MAX}
              rows={8}
              placeholder={
                'Launch the game, head to the main menu, and pick "Settings -> PlayerBase -> Pair install". Paste the code below into the box that appears.'
              }
              className="w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-text"
            />
          </FormField.Control>
          <FormField.HelpText>
            Discord markdown supported. Up to{' '}
            {PLAYTEST_RECRUITMENT_INSTRUCTIONS_MAX} chars.
          </FormField.HelpText>
        </FormField>
      </Card.Content>
    </Card>
  );
}
